/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MitarbeiterDto } from '../../models/mitarbeiter-dto';

export interface GetMitarbeiterById$Json$Params {

/**
 * Id des Mitarbeiters nach der gesucht werden soll
 */
  mitarbeiterId: string;

/**
 * ob auch ausgetretene Mitarbeiter gefetcht werden können
 */
  includeInactive?: boolean;
}

export function getMitarbeiterById$Json(http: HttpClient, rootUrl: string, params: GetMitarbeiterById$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MitarbeiterDto>> {
  const rb = new RequestBuilder(rootUrl, getMitarbeiterById$Json.PATH, 'get');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.query('includeInactive', params.includeInactive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MitarbeiterDto>;
    })
  );
}

getMitarbeiterById$Json.PATH = '/v1/mitarbeiter/{mitarbeiterId}';
